import React, { Component, useContext } from "react";
import { StepContext } from "../../context/StepContext";
import ContestStartView from "./ContestStartView";
import ContestQuestions from "./ContestQuestions";
import Confirm from "./Confirm";
import Success from "./Success";
import { useState } from "react";

const Contest = (props) => {
    // const [step, setStep] = useState(1);
    const { pageID, pageAfterQuestions } = props;
    const { step, setStep } = useContext(StepContext);

    const nextStepHandler = () => {
        setStep(step + 1);
    };

    const prevStepHandler = () => {
        setStep(step - 1);
    };

    switch (step) {
        case 1:
            return (
                <ContestStartView
                    color={props.color}
                    background={props.background}
                    description={props.description}
                    nextStepHandler={nextStepHandler}
                />
            );
        case 2:
            return (
                <ContestQuestions
                    color={props.color}
                    background={props.background}
                    pageID={pageID}
                />
            );
        case 3:
            return (
                <Confirm
                    nextStepHandler={nextStepHandler}
                    prevStepHandler={prevStepHandler}
                    pageID={pageID}
                    pageAfterQuestions={pageAfterQuestions}
                />
            );
        case 4:
            return (
                <Success
                    color={props.color}
                    background={props.background}
                    endPageContent={props.endPageContent}
                />
            );
        default:
            console.log("react-app");
    }
};

export default Contest;
